import { array, number, object, string } from 'yup'


export const dorSchema = searchID => object({
	...!searchID && { officePickupID: number().required('Offices is required') },
	currency: string().required('Currency is required'),
	lor: string().required('Length of Rental is required'),
})